var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkGreenCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99967 13.6663C10.6816 13.6663 13.6663 10.6816 13.6663 6.99967C13.6663 3.31778 10.6816 0.333008 6.99967 0.333008C3.31778 0.333008 0.333008 3.31778 0.333008 6.99967C0.333008 10.6816 3.31778 13.6663 6.99967 13.6663ZM10.0889 5.92226C10.4144 5.59683 10.4144 5.06919 10.0889 4.74375C9.76349 4.41832 9.23586 4.41832 8.91042 4.74375L6.16634 7.48783L5.08893 6.41042C4.76349 6.08498 4.23586 6.08498 3.91042 6.41042C3.58498 6.73586 3.58498 7.26349 3.91042 7.58893L5.57709 9.2556C5.90252 9.58103 6.43016 9.58103 6.7556 9.2556L10.0889 5.92226Z",
    fill: "#285E63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkGreenCheck);
export default __webpack_public_path__ + "static/media/dark-green-check.e44b216caa3f0220511bae73b6bf7c85.svg";
export { ForwardRef as ReactComponent };